var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "roleBg",
    fill: "#77779F",
    d: "M5.5 9.5h4v-4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "roleBg",
    fill: "#77779F",
    d: "M15 15V1.172l-2.651 2.652v8.525H3.823L1.173 15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0v13.828l2.651-2.652V2.651h8.526L13.827 0z"
  }))));
}
export default __webpack_public_path__ + "static/svg/roles/top.svg";
export { SvgTop as ReactComponent };